<template>
    <div>
        <div v-if="dialogVisible">
            <el-form :model="form" :rules="rules" ref="form" @submit.prevent.native="onSubmit('form')">
                <el-form-item label="Associated Recipe" prop="id">
                    <el-select v-model="form.id" placeholder="Select a recipe" remote filterable no-data-text="No matching recipes found." :remote-method="onQueryChange">
                        <el-option v-for="recipe in recipes" :key="recipe.id" :label="recipe.title" :value="recipe.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-button native-type="submit" type="primary" :loading="loading">Save</el-button>
                <el-button @click="onCancel('form')">Cancel</el-button>
            </el-form>
        </div>
        <div v-else>
            <el-button type="primary" size="mini" @click="setVisible(true)">
                Add Association
            </el-button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            dialogVisible: false,
            recipes: [],
            form: {
                id: '',
            },
            rules: {
                id: [
                    { required: true, message: 'Select a recipe.', trigger: 'blur' },
                ],
            },
        }
    },

    props: {
        recipeId: {
            required: true,
            type: String,
        },
    },

    methods: {
        async onQueryChange(keyword) {
            if (!keyword) {
                this.recipes = []

                return false
            }

            try {
                var { data } = await this.$http.get('/recipes', {
                    params: { keyword },
                })
            } catch(err) {
                this.$message.error(err.response.data.message)

                return false
            }

            this.recipes = data
        },

        onSubmit(form) {
            this.loading = true

            this.$refs[form].validate(async valid => {
                if (!valid) {
                    this.loading = false

                    return false
                }

                try {
                    var { data } = await this.$http.post(`/recipes/${ this.recipeId }/association`, {
                        recipe_id: this.form.id,
                    })
                } catch(err) {
                    this.$message.error(err.response.data.message)

                    return false
                } finally {
                    this.loading = false
                }

                this.setVisible(false)
                this.$refs[form].resetFields()
                this.$emit('create')
                this.$message.success(data.message)
            })
        },

        onCancel(form) {
            this.setVisible(false)
            this.$refs[form].resetFields()
        },

        setVisible(status) {
            this.dialogVisible = status
        },
    },
}
</script>
